<div style="padding: 0 16px">
  <h1>404</h1>
  <h1>Страница не найдена</h1>
</div>
